import React from 'react';
import { scroller, Element } from "react-scroll";
import {Button} from "antd";

import "./index.css";
import "../../../views/index.css";
import image1 from "../../../assets/images/Code typing-rafiki.svg";
import image2 from "../../../assets/images/Code review-amico.svg";



const Collaboration = () => {

    const scrollToCourse = () => {
        scroller.scrollTo('course', {
            duration: 800,
            delay: 100,
            smooth: true
        })
    }

    return (
        <>
            <div className="collaboration">
                <img src={image1} alt="image 1" width="40%" />
                <div style={{ padding: "35px" }}>
                    <h2 style={{ fontSize: "40px", fontWeight: "bolder" }}>Transform your life through education</h2>
                    <p style={{ fontSize: "20px" }}>Learners around the world are launching new careers, advancing in their fields, and enriching their lives.</p>
                    <Button size="large" className="mybutton" type="primary"  onClick={scrollToCourse}> Take Course </Button>
                </div>
            </div>
            <div className="parteners">
                <h1 style={{fontWeight: "bolder"}}>Our Parteners</h1>
            </div>
            <div className="collaboration">

                <div style={{ padding: "35px" }}>
                    <h2 style={{ fontSize: "40px", fontWeight: "bolder" }}>Gender Quality In Coding Career</h2>
                    <p style={{ fontSize: "20px" }}>We encourage females to join coding career, through program of {"<SheCanCode/>"}</p>
                    <a href="https://www.shecancodeschool.org/#" target="_blank"> <Button size="large" className="mybutton" type="primary" >Apply</Button></a>
                </div>
                <img src={image2} alt="image 1" width="40%" />
            </div>
        </>
    )
}

export default Collaboration;